import Vue from 'vue';
import Vuex from 'vuex';
import view from './view';
import main from './modules/main';
import product from './modules/product';

import 'es6-promise/auto';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    view,
    main,
    product
  },
  strict: debug
});
